// extracted by mini-css-extract-plugin
export var layoutContainer = "_bs-0";
export var layoutContainerNoRounding = "_bs-6";
export var layoutContainerOpen = "_bs-5";
export var layoutContainerResizing = "_bs-1";
export var mainContent = "_bs-2";
export var resizeDivider = "_bs-3";
export var slidePanel = "_bs-4";